import React, { useMemo } from "react";
import "./styles.scss";
import { type HeadingProps } from "./KC_Heading1";
import { buildCls } from "../../../utils/helpers/buildCls";

export default function KC_Heading2(props: HeadingProps) {
  const className = useMemo(() => {
    const cls = [
      "kc-heading",
      "kc-heading-2",
      props.className ?? "",
      props.primary ? "text-blue" : "",
      props.secondary ? "text-secondary" : ""
    ];
    return buildCls(cls);
  }, [props.primary, props.secondary, props.className]);
  return (
    <h2 id={props.id} className={className} style={props.style}>
      {props.text}
    </h2>
  );
}
